import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import styled from "styled-components";

import { itemStyles } from "./Dropdown.styles";

export const Item = styled(DropdownMenu.Item)<{ $isSelected?: boolean }>`
  ${itemStyles};
`;
